var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('h4',{directives:[{name:"t",rawName:"v-t",value:('tips.tip'),expression:"'tips.tip'"}],staticClass:"title"}),_c('small',[_vm._t("content")],2)])}
var staticRenderFns = []

export { render, staticRenderFns }